/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {ILayerConfig, ILayersConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {
    CustomLayerScaleOptions,
    LayerScaleOption,
    ScaleMethod,
    ScaleTarget
} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";

export interface IFITHLayerConfig extends ILayersConfig {
    readonly BACKGROUND: ILayerConfig;
    readonly REEL_BACKGROUND: ILayerConfig;
    readonly ANTICIPATION: ILayerConfig;
    readonly SYMBOLS: ILayerConfig;
    readonly B_WIN: ILayerConfig;
    readonly HIGHLIGHT_SLOT: ILayerConfig;
    readonly REEL_OVERLAY: ILayerConfig;
    readonly WIN_WAYS_BOARD: ILayerConfig;
    readonly WILD_MULTIPLIER_BOARD: ILayerConfig;
    readonly BONUS_OVERLAY_V_SYMBOLS: ILayerConfig;
    readonly BONUS_OVERLAY: ILayerConfig;
    readonly BONUS_OVERLAY_ANIMATIONS: ILayerConfig;
    readonly SYMBOL_WIN_ANIMATIONS: ILayerConfig;
    readonly WILD_EXPLODE_SPARKLE: ILayerConfig;
    readonly WILD_MINING: ILayerConfig;
    readonly WIN_NUMBERS: ILayerConfig;
    readonly BET_LINES: ILayerConfig;
    readonly LOGO: ILayerConfig;
    readonly BIG_WIN_BG: ILayerConfig;
    readonly BIG_WIN_FOUNTAIN: ILayerConfig;
    readonly BIG_WIN: ILayerConfig;
    readonly BIG_WIN_SMOKE: ILayerConfig;
    readonly BIG_WIN_EXPLODE: ILayerConfig;
    readonly WIN_COUNT_UP: ILayerConfig;
    readonly FREESPIN: ILayerConfig;
    readonly INTRO: ILayerConfig;
    readonly BUTTON: ILayerConfig;
}

export class FITHLayerConfig {
    public static defaultLayerScaleOptions: IDeviceDependentConfig<LayerScaleOption> = {
        desktop: {landscape: LayerScaleOption.REELS_FIT_STAGE},
        mobile: {
            landscape: LayerScaleOption.REELS_FIT_STAGE,
            portrait: LayerScaleOption.REELS_FIT_STAGE
        }
    };

    public static customOptions: CustomLayerScaleOptions = {
        frame: {x: 0, y: 0, width: 720, height: 620},
        placement: {
            desktop: {
                landscape: {x: 0.5, y: 0.5}
            },
            mobile: {
                landscape: {x: 0.5, y: 0.5},
                portrait: {x: 0.5, y: 0.5}
            }
        },
    };

    public static reelBackground: CustomLayerScaleOptions = {
        target: {
            desktop: {
                landscape: ScaleTarget.STAGE
            },
            mobile: {
                landscape: ScaleTarget.STAGE,
                portrait: ScaleTarget.WINDOW
            }
        },
        placement: {
            desktop: {
                landscape: {x: 0.5, y: 1}
            },
            mobile: {
                landscape: {x: 0.5, y: 1},
                portrait: {x: 0.5, y: 1}
            }
        },
        method: {
            desktop: {
                landscape: ScaleMethod.FIT
            },
            mobile: {
                landscape: ScaleMethod.FIT,
                portrait: ScaleMethod.FIT
            }
        }
    };

    public static introConfig: CustomLayerScaleOptions = {
        target: ScaleTarget.WINDOW,
        method: ScaleMethod.FIT,
        frame: {x: 0, y: 0, width: 720, height: 720},
        placement: {x: 0.5, y: 0.5}
    };

    public static BACKGROUND: ILayerConfig = {
        name: "BACKGROUND",
        customOptions: FITHLayerConfig.introConfig
    };

    public static REEL_BACKGROUND: ILayerConfig = {
        name: "REEL_BACKGROUND",
        customOptions: FITHLayerConfig.reelBackground
    };

    public static ANTICIPATION: ILayerConfig = {
        name: "ANTICIPATION",
        customOptions: FITHLayerConfig.reelBackground
    };

    public static SYMBOLS: ILayerConfig = {
        name: "SYMBOLS",
        customOptions: FITHLayerConfig.customOptions
    };

    public static B_WIN: ILayerConfig = {
        name: "B_WIN",
        customOptions: FITHLayerConfig.customOptions
    };

    public static HIGHLIGHT_SLOT: ILayerConfig = {
        name: "HIGHLIGHT_SLOT",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BONUS_OVERLAY_V_SYMBOLS: ILayerConfig = {
        name: "BONUS_OVERLAY_V_SYMBOLS",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BONUS_OVERLAY: ILayerConfig = {
        name: "BONUS_OVERLAY",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BONUS_OVERLAY_ANIMATIONS: ILayerConfig = {
        name: "BONUS_OVERLAY_ANIMATIONS",
        customOptions: FITHLayerConfig.customOptions
    };

    public static REEL_OVERLAY: ILayerConfig = {
        name: "REEL_OVERLAY",
        customOptions: FITHLayerConfig.customOptions
    };

    public static WIN_WAYS_BOARD: ILayerConfig = {
        name: "WIN_WAYS_BOARD",
        customOptions: FITHLayerConfig.customOptions
    };

    public static WILD_MULTIPLIER_BOARD: ILayerConfig = {
        name: "WILD_MULTIPLIER_BOARD",
        customOptions: FITHLayerConfig.customOptions
    };

    public static SYMBOL_WIN_ANIMATIONS: ILayerConfig = {
        name: "SYMBOL_WIN_ANIMATIONS",
        customOptions: FITHLayerConfig.customOptions
    };

    public static WILD_EXPLODE_SPARKLE: ILayerConfig = {
        name: "WILD_EXPLODE_SPARKLE",
        customOptions: FITHLayerConfig.customOptions
    };

    public static WILD_MINING: ILayerConfig = {
        name: "WILD_MINING",
        customOptions: FITHLayerConfig.customOptions
    };

    public static WIN_NUMBERS: ILayerConfig = {
        name: "WIN_NUMBERS",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BET_LINES: ILayerConfig = {
        name: "BET_LINES",
        customOptions: FITHLayerConfig.customOptions
    };

    public static LOGO: ILayerConfig = {
        name: "LOGO",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BIG_WIN_BG: ILayerConfig = {
        name: "BIG_WIN_BG",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BIG_WIN_FOUNTAIN: ILayerConfig = {
        name: "BIG_WIN_FOUNTAIN",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BIG_WIN: ILayerConfig = {
        name: "BIG_WIN",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BIG_WIN_SMOKE: ILayerConfig = {
        name: "BIG_WIN_SMOKE",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BIG_WIN_EXPLODE: ILayerConfig = {
        name: "BIG_WIN_EXPLODE",
        customOptions: FITHLayerConfig.customOptions
    };

    public static WIN_COUNT_UP: ILayerConfig = {
        name: "WIN_COUNT_UP",
        customOptions: FITHLayerConfig.customOptions
    };

    public static FREESPIN: ILayerConfig = {
        name: "FREESPIN",
        customOptions: FITHLayerConfig.customOptions
    };

    public static INTRO: ILayerConfig = {
        name: "INTRO",
        customOptions: FITHLayerConfig.customOptions
    };

    public static BUTTON: ILayerConfig = {
        name: "BUTTON",
        customOptions: FITHLayerConfig.customOptions
    };

    public static getConfig(): IFITHLayerConfig {
        return {
            BACKGROUND: FITHLayerConfig.BACKGROUND,
            REEL_BACKGROUND: FITHLayerConfig.REEL_BACKGROUND,
            ANTICIPATION: FITHLayerConfig.ANTICIPATION,
            SYMBOLS: FITHLayerConfig.SYMBOLS,
            B_WIN: FITHLayerConfig.B_WIN,
            HIGHLIGHT_SLOT: FITHLayerConfig.HIGHLIGHT_SLOT,
            REEL_OVERLAY: FITHLayerConfig.REEL_OVERLAY,
            WIN_WAYS_BOARD: FITHLayerConfig.WIN_WAYS_BOARD,
            WILD_MULTIPLIER_BOARD: FITHLayerConfig.WILD_MULTIPLIER_BOARD,
            BONUS_OVERLAY_V_SYMBOLS: FITHLayerConfig.BONUS_OVERLAY_V_SYMBOLS,
            BONUS_OVERLAY: FITHLayerConfig.BONUS_OVERLAY,
            BONUS_OVERLAY_ANIMATIONS: FITHLayerConfig.BONUS_OVERLAY_ANIMATIONS,
            SYMBOL_WIN_ANIMATIONS: FITHLayerConfig.SYMBOL_WIN_ANIMATIONS,
            WILD_EXPLODE_SPARKLE: FITHLayerConfig.WILD_EXPLODE_SPARKLE,
            WILD_MINING: FITHLayerConfig.WILD_MINING,
            WIN_NUMBERS: FITHLayerConfig.WIN_NUMBERS,
            BET_LINES: FITHLayerConfig.BET_LINES,
            LOGO: FITHLayerConfig.LOGO,
            BIG_WIN_BG: FITHLayerConfig.BIG_WIN_BG,
            BIG_WIN_FOUNTAIN: FITHLayerConfig.BIG_WIN_FOUNTAIN,
            BIG_WIN: FITHLayerConfig.BIG_WIN,
            BIG_WIN_SMOKE: FITHLayerConfig.BIG_WIN_SMOKE,
            BIG_WIN_EXPLODE: FITHLayerConfig.BIG_WIN_EXPLODE,
            WIN_COUNT_UP: FITHLayerConfig.WIN_COUNT_UP,
            FREESPIN: FITHLayerConfig.FREESPIN,
            INTRO: FITHLayerConfig.INTRO,
            BUTTON: FITHLayerConfig.BUTTON
        };
    }
}